import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { VisuallyHidden } from "components/ui/VisuallyHidden";
import calcentralLogo from "assets/templates/svg/calcentral_logo.svg";
import calcentralLogoPrint from "assets/templates/svg/calcentral_logo_print.svg";
import UserPopover from "../../StatusIcons/UserPopover";
import { NoPrint, PrintOnly } from "../PrintHelpers";
import { HamburgerButton } from "../HamburgerButton";
import { BConnectedButtons } from "components/BConnectedButtons";
import { useSlice } from "components/hooks/useSlice";

export function SiteHeader({ menuOpen, setMenuOpen }) {
  const { isLoggedIn } = useSlice("myStatus");

  return (
    <>
      <NoPrint>
        <HeaderStyles>
          <HamburgerButton onClick={() => setMenuOpen(!menuOpen)}>
            <i className="fa fa-bars" />
            <VisuallyHidden>Menu</VisuallyHidden>
          </HamburgerButton>
          <Link className="logo" to="/">
            <img src={calcentralLogo} alt="CalCentral" />
          </Link>

          {isLoggedIn && (
            <div
              style={{
                display: `flex`,
                flexDirection: `row`,
                gap: `var(--lg)`,
              }}
            >
              <BConnectedButtons />
              <UserPopover />
            </div>
          )}
        </HeaderStyles>
      </NoPrint>
      <PrintOnly>
        <img src={calcentralLogoPrint} alt="CalCentral" />
      </PrintOnly>
    </>
  );
}

SiteHeader.displayName = "SiteHeader";
SiteHeader.propTypes = {
  menuOpen: PropTypes.bool,
  setMenuOpen: PropTypes.func,
};

const HeaderStyles = styled.header`
  background: var(--prussian-blue);
  color: white;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-right: 10px;
  padding-top: 6px;

  a.logo {
    display: none;
  }

  @media only screen and (min-width: 768px) {
    a.logo {
      display: block;
      margin-left: 10px;
      width: 185px;
      height: 35px;
      overflow: hidden;

      &:hover {
        border-bottom: 2px solid var(--buttercup);
      }
    }

    button.hamburger {
      display: none;
    }
  }
`;
